/**
 * Shared responsive breakpoints (px, max-width cutoffs) for JS-side
 * matchMedia/window.innerWidth checks across the studio apps. Keeping a
 * single source of truth here prevents components from drifting to
 * slightly different numbers (e.g. 1023 vs 1024) and disagreeing about
 * where "mobile"/"tablet"/"desktop" starts.
 *
 * These are for JS logic only — CSS media queries can't reference them
 * directly and must keep matching literal px values in their own files.
 */
export const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
} as const;
